var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer" }, [
    _c("div", { staticClass: "cwrap" }, [
      _c("div", { staticClass: "lefts" }, [
        _c("div", { staticClass: "tit" }, [_vm._v("金基窝")]),
        _vm._v(" "),
        _c("div", { staticClass: "foot-links" }, [
          _c("span", [
            _c("a", { attrs: { href: _vm.__C.urlForJjw + "/tzzqyxz.html" } }, [
              _vm._v("投资者权益须知")
            ])
          ]),
          _vm._v(" "),
          _c("span", [
            _c("a", { attrs: { href: _vm.__C.urlForJjw + "/fxtsh.html" } }, [
              _vm._v("风险提示函")
            ])
          ]),
          _vm._v(" "),
          _c("span", [
            _c("a", { attrs: { href: _vm.__C.urlForJjw + "/topublicity" } }, [
              _vm._v("公示信息")
            ])
          ])
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1)
      ]),
      _vm._v(" "),
      _vm._m(2)
    ]),
    _vm._v(" "),
    _vm._m(3)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info clearfix" }, [
      _c("div", { staticClass: "sprite foot-logo" }),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n                    办公地址：辽宁省沈阳市浑南区白塔二南街18-2号B座601"
        ),
        _c("i", { staticClass: "emsp" }),
        _vm._v("邮编：110169"),
        _c("br"),
        _vm._v("\n                    版权所有"),
        _c("i", { staticClass: "emsp" }),
        _vm._v("财咨道信息技术有限公司"),
        _c("i", { staticClass: "emsp" }),
        _c(
          "a",
          { attrs: { href: "http://www.miibeian.gov.cn", target: "_blank" } },
          [_vm._v("辽ICP备11018762号-4")]
        ),
        _c("i", { staticClass: "emsp" }),
        _c(
          "a",
          {
            attrs: {
              href:
                "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=21011202000123",
              target: "_blank"
            }
          },
          [_vm._v("辽公网安备21011202000123号")]
        ),
        _vm._v(" "),
        _c("span", { staticClass: "sprite" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "tips",
        staticStyle: { "margin-top": "20px", float: "left" }
      },
      [
        _c("p", [_vm._v("数据来源：恒生-聚源数据库")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "数据仅供参考，不构成对投资者收益及本金不受损失的任何保证，基金及理财产品的信息和数据由管理人提"
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "供，我司不保证信息的准确性和真实性，基金及理财产品的过往业绩并不预示其未来表现。管理人管理的其"
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "他基金及理财产品的业绩并不构成基金及理财产品业绩表现的保证，产品收益具有波动风险。"
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "投资者应注意投资风险，认真阅读基金产品信息、产品合同等相关法律文件，理解相关业务规则、重"
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "要声明及风险提示的全部内容，自主做出投资决策，并自行承担投资风险，市场有风险投资需谨慎。"
          )
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "rights" }, [
      _c("div", { staticClass: "wechat" }, [
        _c("img", {
          attrs: {
            src: "/accountcenter/static/images/wechat-ercode.png",
            alt: ""
          }
        }),
        _vm._v(" "),
        _c("span", [_vm._v("微信公众号:"), _c("i", [_vm._v("jinjiwo2018")])])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contact-infos" }, [
        _c("strong", [_vm._v("客服/投诉热线：")]),
        _vm._v(" "),
        _c("p", [
          _c("span", { staticClass: "tel" }, [_vm._v("400-003-5811")]),
          _vm._v(" "),
          _c("span", { staticClass: "date" }, [
            _vm._v("(工作日上午9:00-下午18:00)")
          ])
        ]),
        _vm._v(" "),
        _c("strong", [_vm._v("客服/投诉邮箱：")]),
        _vm._v(" "),
        _c("p", [
          _c("span", { staticClass: "email" }, [
            _vm._v("jijin@win-stock.com.cn")
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "copyright" }, [
      _c("div", { staticClass: "cwraps" }, [
        _vm._v(
          "\n            © Copyright ©2007-2015 财咨道信息技术有限公司 版权所有 辽ICP备11018762号-4\n        "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10e356bb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10e356bb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bottom.vue
// module id = sBEu
// module chunks = 1 2 3 4 5 6 7 8